/**
 * Warehouse konstante
 */

export const SHIFT_KEYS = ["one", "two", "three", "four"];
export const DEFAULT_SHIFTS = [1, 2, 3, 4];
